// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","separatorGrey":"#eceeee","body":"_2lYHSCAcM6vA2s-47YYZeS","textGrey":"#3f3f3f","container":"_1CPiNwqxnyaYd1KWWSF3SW","textRow":"_2lb-WgF1fzSu35-pYPYeDl","text":"_1wCgLOyswGtSCUXfPUyOlg _2lYHSCAcM6vA2s-47YYZeS"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/shipping-options/shipping-summary/ShippingSummary.css
// module id = 805
// module chunks = 0